import { render, staticRenderFns } from "./taskSkillLayout.vue?vue&type=template&id=0af5552b&scoped=true&"
import script from "./taskSkillLayout.vue?vue&type=script&lang=js&"
export * from "./taskSkillLayout.vue?vue&type=script&lang=js&"
import style0 from "./taskSkillLayout.vue?vue&type=style&index=0&id=0af5552b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0af5552b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\svn\\家用后台\\branches\\20240430-1.5.0\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0af5552b')) {
      api.createRecord('0af5552b', component.options)
    } else {
      api.reload('0af5552b', component.options)
    }
    module.hot.accept("./taskSkillLayout.vue?vue&type=template&id=0af5552b&scoped=true&", function () {
      api.rerender('0af5552b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/robot/task/taskSkillLayout.vue"
export default component.exports